<template>
  <div class="footer">
    <div class="foot">
      <div class="foot_one">
        <div class="foot_title">产品中心</div>
        <div class="foot_txt" @click="gotoInfor">信息化产品</div>
        <div class="foot_txt" @click="gotoInfor1">物联网产品</div>
        <div class="foot_txt" @click="gotoInfor2">智能AI产品</div>
      </div>
      <div class="foot_two">
        <div class="foot_title">成功案例</div>
        <div class="foot_txt"  @click="gotoMoreInfor">基于RFID的接地线管理系统</div>
        <div class="foot_txt" @click="gotoMoreInfor1">变电站音频指纹分析</div>
        <div class="foot_txt" @click="gotoMoreInfor2">履带式巡检机器人</div>
      </div>
      <div class="foot_three">
        <div class="foot_title">联系我们</div>
        <div class="foot_txt">售后服务：sepc_zhouqi@126.com</div>
        <div class="foot_txt">商务合作：sepc_zhouqi@126.com</div>
        <div class="foot_txt">联系电话：17749783735</div>
        <div class="foot_txt">公司地址：上海市黄浦区春申江大厦1403</div>
      </div>
      <div class="foot_four">
        <div class="foot_title">微信扫一扫</div>
        <img src="../assets/gswx.jpg" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import router from '../router/index'
export default {
  methods: {
    gotoInfor() {
      router.push('/information')
    },
    gotoInfor1() {
      router.push('/information1')
    },
    gotoInfor2() {
      router.push('/information2')
    },
    gotoMoreInfor() {
      router.push('/moreInfor')
    },
    gotoMoreInfor1() {
      router.push('/moreInfor8')
    },
    gotoMoreInfor2() {
      router.push('/moreInfor5')
    },
  }
}
</script>
<style scoped>
  .footer {
  background-color: #222;
  height: 220px;
  color: #ddd;
  display: flex;
}
.foot {
  display: flex;
  /* align-items: center; */
  margin: 0 auto;
}
.foot .foot_title {
  margin-top: 50px;
  font-size: 18px;
  margin-bottom: 10px;
}
.foot .foot_txt {
  font-size: 14px;
  margin-bottom: 7px;
  cursor: pointer;
}
.foot_two {
  margin-left: 90px;
}
.foot_three {
  margin-left: 90px;
}
.foot_four {
  margin-left: 150px;
}
.foot_four img {
  margin-top: 10px;
  width: 90px;
  height: 90px;
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue